export default __webpack_public_path__ + "static/media/etmax.2d34c6ff.png";